module.exports = __webpack_public_path__ + "img/Feature.73a07c6b.png";